/* eslint-disable @typescript-eslint/naming-convention */
import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { CheckoutInfo, CreatePaymentParams } from '../types'
import { Environment } from '../utils/environment'

class Api {
  private axiosInstance: AxiosInstance

  constructor() {
    this.axiosInstance = axios.create({
      baseURL: Environment.apiUrl,
    })

    this.axiosInstance.interceptors.response.use(
      (response: AxiosResponse) => response.data,
      (error: AxiosError) => Promise.reject(error)
    )
  }

  public getCheckoutInfo(session: string): Promise<CheckoutInfo> {
    return this.axiosInstance.get('/checkout-info/' + session)
  }

  public createPayment(params: CreatePaymentParams) {
    return this.axiosInstance.post(
      '/checkout/payment',
      params,
      {
        headers: {
          'x-organization-code': params.organization_code,
          'x-account-code': params.account_code,
          'public-api-key': params.public_api_key,
          'x-idempotency-key': uuidv4(),
        },
      }
    )
  }
}

export const api = new Api()
